import React from 'react';
import {GlobalStyle} from '../components/UsableComponents/GlobalStyle';
import SellCrypto from '../components/SellCrypto/SellCrypto';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {graphql} from "gatsby";

const IndexPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('metaTitle')}</title>
                <meta name="description" content={t('metaContent')} />
                <meta name="keywords" content={t('metaKeywords')} />
            </Helmet>
            <GlobalStyle/>
            <SellCrypto/>
        </>
    )

};

export default IndexPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
